
import { defineComponent } from "vue";
export default defineComponent({
  name: "FooterSchedule",
  data() {
    return {};
  },
  methods: {
    getYearToday(): string{
      const today = new Date();
      return String(today.getFullYear())
    }
  },
});
